module.exports = __webpack_public_path__ + "static/banner.contact-f48c493759c5eb48c7c0f588b994756e.png";